
import Component from "vue-class-component";
import { mixins } from "vue-class-component";
import { ServicesNomenclatureMix } from "./ServicesNomenclatureMix";
import {
    IServicesCategoryNomenclature, IServicesCategoryNomenclatureListItem
} from "@/entity/servicesCategoryNomenclature/services.category.nomenclature.types";
import {ServicesCategoryNomenclatureStore} from "@/store/modules/ServicesCategoryNomenclature";

@Component
export class ServiceCategoryNomenclatureMix extends mixins(ServicesNomenclatureMix) {
    get servicesCategory(): IServicesCategoryNomenclature | null {
        return ServicesCategoryNomenclatureStore.items;
    }
    get serviceCategory(): IServicesCategoryNomenclatureListItem | null {
        return ServicesCategoryNomenclatureStore.item;
    }
}
